export default "__VITE_ASSET__D6dSz2yG__"